/* eslint-disable @typescript-eslint/no-require-imports */
export const liste = [
    {
      title: 'Demander un devis',
      source: require('../../ressources/images/IconMonEspace/Graph.png'),
    },
    {
      title: 'Souscrire un contrat',
      source: require('../../ressources/images/IconMonEspace/Folder.png'),
      montant: '',
    },
    {
      title: 'Mes contrats',
      source: require('../../ressources/images/IconMonEspace/Work.png'),
      montant: '',
    },
    {
      title: 'Mes sinistres',
      source: require('../../ressources/images/IconMonEspace/ShieldFail.png'),
    },
    {
      title: 'Paiement',
      source: require('../../ressources/images/IconMonEspace/Wallet.png'),
    },
    {
      title: 'Notifications',
      source: require('../../ressources/images/IconMonEspace/Notification.png'),
    },
    {
      title: 'Mon Profil',
      source: require('../../ressources/images/IconMonEspace/Profile.png'),
    },
  ];